import React from "react"
import Ionicon from "react-ionicons"
import {values, keys, find, findIndex, get, set, cloneDeep} from "lodash"
import PropTypes from "prop-types"

import MenuModal from './components/MenuModal.jsx'


import './Reservation.Menu.less'

export default class MenuPicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      showModal: false,
      menuToShow: ""
    }
  }

  changeCount(menu, count) {
    const selectedMenus = cloneDeep(this.props.value)
    const menuStored = find(
      this.props.value, 
      (mn) => menu.id == mn.id
    )
    const menuStoredIndex = findIndex(
      this.props.value, 
      (mn) => menu.id == mn.id
    )
    const newMenu = {id: menu.id, name: menu.name, count: Math.max(0, get(menuStored, "count", 0) + count)}
    if (menuStoredIndex == -1) selectedMenus.push(newMenu) 
    else selectedMenus[menuStoredIndex] = newMenu
    this.props.onChange(selectedMenus.filter(mn => mn.count > 0))
  }

  getPrice() {
    return this.props.value.map(menu => menu.count * this.props.menus[menu.id].price).reduce((a, b) => a + b, 0)
  }

  getTotalCount() {
    return this.props.value.map(menu => menu.count).reduce((a, b) => a + b, 0)
  }

  render() {
    const { menus, persons, value} = this.props
    return  (
      <React.Fragment>
        <div className="menuPicker" id="menuPicker">
          <div className="topbar">
            <p>
                请选择
              {persons}
                份套餐
            </p>
            <div className="basket">
              <Ionicon icon="ios-basket" size="20px" color="#E12968"  />
              <p>{this.getTotalCount()}</p>
              <p className="eurprice">
                {this.getPrice()}
                €
              </p>
            </div>
          </div>

          <div className="menusContainer">
            {values(menus).filter(menu => !menu.hidden).map(menu => {
              const menuStored = find(
                value, 
                (mn) => menu.id == mn.id
              )
              return (
                <div 
                  key={menu.id} 
                  className="menu" 
                  style={{backgroundImage: `url(${menu.background.image})`}}
                  onClick={() => this.setState({showModal: true, menuToShow: menu})}
                >
                  <div className="cover">
                    <div className="menuInfo">
                      <p className="menuName">{menu.chName}</p>
                      <div className="tags">
                        <div className="price">
                          {menu.price}
                        欧/人
                        </div>
                        <div className="moreInfo">
                        套餐内容 
                          {' '}
                          {">"}
                        </div>
                      </div>
                    </div>
                    <div className="buttonGroup">
                      {menuStored && menuStored.count > 0 && (
                        <React.Fragment>
                          <div 
                            className="countButton delete"
                            onClick={event => {
                              event.stopPropagation()
                              this.changeCount(menu, -1)
                            }}
                          >
                            <Ionicon icon="md-remove" size="40px" color="white"  />
                          </div>
                          <div className="menucount">{menuStored ? menuStored.count : 0}</div>
                        </React.Fragment>
                      )}
                      <div 
                        className="countButton"
                        onClick={event => {
                          event.stopPropagation()
                          this.changeCount(menu, 1)
                        }}
                      >
                        <Ionicon icon="md-add" size="40px" color="white"  />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {this.state.showModal && (
          <MenuModal 
            onClose={() => this.setState({showModal: false})}
            menu={this.state.menuToShow}
          />
        )}
      </React.Fragment>
      
    )
  }
}

MenuPicker.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.object).isRequired, 
  persons: PropTypes.number.isRequired, 
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.Menu.jsx